<template>
  <v-container fluid>
    <v-tabs v-model="tabs" fixed-tabs background-color="indigo" dark flat>
      <v-tab>BANCARIO</v-tab>
      <v-tab>FOVISSSTE</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-card outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="successAction" />
              </v-col>
              <v-col cols="12">
                <ViewDetails class="ma-5" :object="object" type="Banks" :itemsAction="successAction"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <DataTableMain :datatable="tableFovissste" :on-success="successAction" :itemsAction="successAction" />
              </v-col>
              <v-col cols="12">
                <ViewDetails class="ma-5" :object="objectTwo" type="Banks" :itemsAction="successAction"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

    </v-tabs-items>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="main" :urls="urls" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    tabs: null,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'config.banks-store' }
        ],
        titles: [
          // { text: 'Tipo de Credito', value: 'tipo_calculo', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Nombre Tasa', value: 'tasa_nombre', class: 'black--text' },
          { text: 'Tasa', value: 'tasa', class: 'black--text' },
          { text: 'Dias por Mes', value: 'dias_mes', class: 'black--text' },
          { text: 'Dias por Año', value: 'dias_anio', class: 'black--text' },
          { text: 'Seguro de Daños', value: 'seguroddanios', class: 'black--text' },
          { text: 'Comision', value: 'comision', class: 'black--text' },
          { text: 'Plazos', value: 'NombrePlazos', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: 'config.banks-update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'deleteData', code: 'config.banks-delete' }
          // { title: 'Agregar Plazos', icon: 'mdi-checkbox-multiple-blank', color: 'green darken-2', action: 'addDeadlinesData', code: 'config.deadlines-store' }
        ]
      },
      footer: {
        paging: true
      }
    },
    tableFovissste: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'config.banks-store' }
        ],
        titles: [
          // { text: 'Tipo de Credito', value: 'tipo_calculo', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Nombre Tasa', value: 'tasa_nombre', class: 'black--text' },
          { text: 'Tasa', value: 'tasa', class: 'black--text' },
          { text: 'Dias por Mes', value: 'dias_mes', class: 'black--text' },
          { text: 'Dias por Año', value: 'dias_anio', class: 'black--text' },
          { text: 'Seguro de Daños', value: 'seguroddanios', class: 'black--text' },
          { text: 'Comision', value: 'comision', class: 'black--text' },
          { text: 'Plazos', value: 'NombrePlazos', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: 'config.banks-update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'deleteData', code: 'config.banks-delete' }
          // { title: 'Agregar Plazos', icon: 'mdi-checkbox-multiple-blank', color: 'green darken-2', action: 'addDeadlinesData', code: 'config.deadlines-store' }
        ]
      },
      footer: {
        paging: true
      }
    },
    main: {},
    form: [],
    urls: '',
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog,
    ViewDetails
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableFovissste })
  },
  methods: {
    ...mapActions(['PostListObjects', 'DeleteObject', 'DeleteDetailObject']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      if (this.tabs === 0) {
        this.table.header.loading = true
        this.PostListObjects({ url: '/config/banks', data: { tipo: 'CREDITO BANCARIO' } })
      }
      this.tableFovissste.header.loading = true
      this.PostListObjects({ url: '/config/banks', data: { tipo: 'CREDITO FOVISSSTE' } })
    },
    newData (item) {
      this.main = {}
      this.form = this.get_BanksForm
      this.urls = '/config/banks/store'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Banco' })
    },
    updateData ({ item }) {
      this.main = item
      this.form = this.get_BanksForm
      this.urls = `/config/banks/${item.id}`
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 850, title: 'Editar Banco' })
    },
    deleteData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.DeleteObject({ url: `/config/banks/${item.id}` })
        }
      })
    },
    addDeadlinesData ({ item }) {
      this.main = { banco_id: item.id }
      this.form = this.get_DeadlinesForm
      this.urls = '/config/deadlines/store'
      this.message = 'Registro Agregado Correctamente'
      const body = { reload: true }
      this.SHOW_DIALOG_MAIN({ type: 'addDeadlines', with: 500, title: 'Nuevo Plazo', body: body })
    },
    updateDeadlinesData ({ item }) {
      this.main = item
      this.form = this.get_DeadlinesForm
      this.urls = `/config/deadlines/${item.id}`
      this.message = 'Registro Agregado Correctamente'
      const body = { reload: true }
      this.SHOW_DIALOG_MAIN({ type: 'addDeadlines', with: 500, title: 'Editar Plazo', body: body })
    },
    deleteDeadlinesData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.DeleteDetailObject({ url: `/config/deadlines/${item.id}` })
        }
      })
    }
  },
  computed: {
    ...mapGetters(['get_objects', 'get_dialogMain', 'get_reload', 'get_objectDelete',
      'get_BanksForm', 'get_DeadlinesForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    },
    objectTwo () {
      if (this.tableFovissste.modelMain.length > 0) {
        return this.tableFovissste.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    tabs (val) {
      console.log('val', val)
      if (val === 0) {
        this.tableFovissste.body.data = []
        this.PostListObjects({ url: '/config/banks', data: { tipo: 'CREDITO BANCARIO' } })
        return
      }
      this.table.body.data = []
      this.PostListObjects({ url: '/config/banks', data: { tipo: 'CREDITO FOVISSSTE' } })
    },
    get_objects (vals) {
      if (this.tabs === 0) {
        this.table.header.loading = false
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
        return
      }
      this.tableFovissste.header.loading = false
      this.tableFovissste.modelMain = []
      if (vals.length > 0) {
        this.tableFovissste.modelMain.push(vals[0])
      }
      this.tableFovissste.body.data = vals
    },
    get_reload (val) {
      if (val.name === 'addDeadlines') {
        if (val === 0) {
          this.table.body.data.map(bank => {
            if (bank.id === val.banco_id) {
              bank.plazos.push(val)
            }
          })
          return
        }
        this.tableFovissste.body.data.map(bank => {
          if (bank.id === val.banco_id) {
            bank.plazos.push(val)
          }
        })
      }
    },
    get_objectDelete (val) {
      if (val) {
        if (val === 0) {
          this.table.header.loading = true
          this.PostListObjects({ url: '/config/banks', data: { tipo: 'CREDITO BANCARIO' } })
        }
        this.tableFovissste.header.loading = true
        this.PostListObjects({ url: '/config/banks', data: { tipo: 'CREDITO FOVISSSTE' } })
      }
    }
  }
}
</script>

<style>

</style>
